import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const probateChecklistsApi = createApi({
  reducerPath: "probateChecklistsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ProbateChecklist"],
  endpoints: (build) => ({
    getAllChecklists: build.query({
      query: ({ status, search } = {}) => ({ url: "/probate/checklists", method: "GET", params: { status, search } }),
      providesTags: ["ProbateChecklist"],
    }),
    getChecklistById: build.query({
      query: (id) => ({ url: `/probate/checklists/${id}`, method: "GET" }),
      providesTags: (result, error, id) => [{ type: "ProbateChecklist", id }],
    }),
    getChecklistForCase: build.query({
      query: (caseId) => ({ url: `/probate/checklists/case/${caseId}`, method: "GET" }),
      providesTags: ["ProbateChecklist"],
    }),
    createChecklist: build.mutation({
      query: (data) => ({ url: "/probate/checklists", method: "POST", body: data }),
      invalidatesTags: ["ProbateChecklist"],
    }),
    updateChecklist: build.mutation({
      query: ({ id, ...data }) => ({ url: `/probate/checklists/${id}`, method: "PUT", body: data }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateChecklist", id }, "ProbateChecklist"],
    }),
    deleteChecklist: build.mutation({
      query: (id) => ({ url: `/probate/checklists/${id}`, method: "DELETE" }),
      invalidatesTags: ["ProbateChecklist"],
    }),
    toggleTask: build.mutation({
      query: ({ id, stageIndex, taskIndex }) => ({ url: `/probate/checklists/${id}/toggle-task`, method: "PATCH", body: { stageIndex, taskIndex } }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateChecklist", id }, "ProbateChecklist"],
    }),
    updateTask: build.mutation({
      query: ({ id, stageIndex, taskIndex, ...data }) => ({ url: `/probate/checklists/${id}/update-task`, method: "PATCH", body: { stageIndex, taskIndex, ...data } }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateChecklist", id }, "ProbateChecklist"],
    }),
    addTask: build.mutation({
      query: ({ id, stageIndex, name, priority, dueDate }) => ({ url: `/probate/checklists/${id}/add-task`, method: "PATCH", body: { stageIndex, name, priority, dueDate } }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateChecklist", id }, "ProbateChecklist"],
    }),
    removeTask: build.mutation({
      query: ({ id, stageIndex, taskIndex }) => ({ url: `/probate/checklists/${id}/remove-task`, method: "PATCH", body: { stageIndex, taskIndex } }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateChecklist", id }, "ProbateChecklist"],
    }),
    addStage: build.mutation({
      query: ({ id, name }) => ({ url: `/probate/checklists/${id}/add-stage`, method: "PATCH", body: { name } }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateChecklist", id }, "ProbateChecklist"],
    }),
    removeStage: build.mutation({
      query: ({ id, stageIndex }) => ({ url: `/probate/checklists/${id}/remove-stage`, method: "PATCH", body: { stageIndex } }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateChecklist", id }, "ProbateChecklist"],
    }),
    linkToCase: build.mutation({
      query: ({ id, caseId }) => ({ url: `/probate/checklists/${id}/link-case`, method: "PATCH", body: { caseId } }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateChecklist", id }, "ProbateChecklist"],
    }),
  }),
});

export const {
  useGetAllChecklistsQuery,
  useGetChecklistByIdQuery,
  useGetChecklistForCaseQuery,
  useCreateChecklistMutation,
  useUpdateChecklistMutation,
  useDeleteChecklistMutation,
  useToggleTaskMutation,
  useUpdateTaskMutation,
  useAddTaskMutation,
  useRemoveTaskMutation,
  useAddStageMutation,
  useRemoveStageMutation,
  useLinkToCaseMutation,
} = probateChecklistsApi;
